// extracted by mini-css-extract-plugin
export default {"moduleWrapper":"ModuleItemWrapper_moduleWrapper__mXwdo"};